'use client'
import { Step as MUIStep, StepLabel as MUIStepButton, Stepper as MUIStepper } from '@mui/material'

import type { ISxProps } from './types'
import { useState } from 'react'
interface IStep<T> {
  value: T
  label: string
}
interface IStepperProps<T> {
  steps: IStep<T>[]
  value: string
  onChange?: (value: T) => void
  sx?: ISxProps
}
function getStepNumber<T>(value: string, steps: IStep<T>[]) {
  return steps.findIndex((step) => step.value === value) || 0
}

export default function Stepper<T>({ steps, sx, value, onChange }: IStepperProps<T>) {
  const [activeStep, setActiveStep] = useState(getStepNumber<T>(value, steps))
  return (
    <MUIStepper activeStep={activeStep} alternativeLabel sx={sx}>
      {steps.map(({ label }, i) => (
        <MUIStep key={i}>
          <MUIStepButton
            onClick={() => {
              if (onChange) onChange(steps[i].value)
              setActiveStep(i)
            }}
          >
            {label}
          </MUIStepButton>
        </MUIStep>
      ))}
    </MUIStepper>
  )
}
